export const modern = [
  {
    number: 'MD100',
    hasModel: false,
  },
  {
    number: 'MD101',
    hasModel: false,
  },
  {
    number: 'MD102',
    hasModel: false,
  },
  {
    number: 'MD103',
    hasModel: false,
  },
  {
    number: 'MD104',
    hasModel: false,
  },
  {
    number: 'MD105',
    hasModel: false,
  },
  {
    number: 'MD106',
    hasModel: false,
  },
  {
    number: 'MD107',
    hasModel: false,
  },
  {
    number: 'MD108',
    hasModel: false,
  },
  {
    number: 'MD109',
    hasModel: false,
  },
  {
    number: 'MD110',
    hasModel: false,
  },
  {
    number: 'MD111',
    hasModel: false,
  },
  {
    number: 'MD112',
    hasModel: false,
  },
  {
    number: 'MD113',
    hasModel: false,
  },
  {
    number: 'MD114',
    hasModel: false,
  },
  {
    number: 'MD115',
    hasModel: false,
  },
  {
    number: 'MD116',
    hasModel: false,
  },
  {
    number: 'MD117',
    hasModel: false,
  },
  {
    number: 'MD118',
    hasModel: false,
  },
  {
    number: 'MD119',
    hasModel: true,
  },
];
